module.exports = __webpack_public_path__ + "img/价格套餐.4a3ca3d9.svg";